import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VueSimpleAlert from "vue-simple-alert";

Vue.use(Vuetify);
Vue.use(VueSimpleAlert);

export default new Vuetify({
});
